import RoutesEnum from 'enums/routes.enum'

export default [
    {
        path: '/errors/no-access',
        name: RoutesEnum.ERROR.NO_ACCESS,
        view: 'errors/NoAccess',
        meta: {
            layout: 'simple',
            title: 'Stranica Bez Pristupa | Bookeraj',
            descritpion:
                'Žao nam je, trenutno nemate pristup ovoj stranici. Molimo vas da se prijavite ili proverite svoje dozvole kako biste dobili pristup.',
        },
    },
]
